import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const accent =
    "https://images.unsplash.com/photo-1774685110718-c5b4fe026144?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export default function CtaBanner() {
    return (
        <section className="relative overflow-hidden" data-testid="cta-banner">
            <div className="absolute inset-0">
                <img
                    src={accent}
                    alt=""
                    className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-brand-ink/70" />
            </div>
            <motion.div
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.8 }}
                className="relative mx-auto max-w-7xl px-6 lg:px-10 py-24 lg:py-32"
            >
                <div className="max-w-3xl text-brand-paper">
                    <div className="text-xs uppercase tracking-[0.25em] text-brand-gold font-semibold mb-5">
                        — Ready when you are
                    </div>
                    <h2 className="font-serif text-4xl lg:text-6xl leading-tight tracking-tight">
                        The right agent is one short conversation away.
                    </h2>
                    <p className="mt-6 text-lg text-brand-paper/80 max-w-xl leading-relaxed">
                        Tell us where you're moving and what matters most. We'll do the
                        legwork and introduce you to agents worth your time.
                    </p>
                    <Link
                        to="/get-started"
                        data-testid="cta-banner-button"
                        className="mt-10 inline-flex items-center gap-3 bg-brand-paper text-brand-ink px-8 py-4 text-sm tracking-wide hover:bg-brand-sand transition-all hover:gap-4"
                    >
                        Get Matched Now!
                        <span aria-hidden>→</span>
                    </Link>
                </div>
            </motion.div>
        </section>
    );
}
